/** The Managers page's URLs: `/managers/<id>` is a profile, the rest are fixed views. */
export const MANAGERS_PATH = "/managers";
export const HALL_OF_FAME_PATH = `${MANAGERS_PATH}/hall-of-fame`;
export const LUCK_PATH = `${MANAGERS_PATH}/luck`;
export const MILESTONES_PATH = `${MANAGERS_PATH}/milestones`;
